import { formatDistanceToNow, format } from "date-fns";
import { LANGUAGES } from "@/utils/config/elevenlabs";

export const formatDuration = (seconds: number, short: boolean = false): string => {
  if (short) {
    // Short format: 5s, 5m, 1h 30m
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) return `${remainingSeconds}s`;
    if (minutes < 60) return `${minutes}m`;

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
  }

  // Long format: 5 seconds, 5 minutes, 5 min 30 sec
  if (seconds < 60) {
    return `${seconds} seconds`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (remainingSeconds === 0) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
  return `${minutes} min ${remainingSeconds} sec`;
};

export const formatSpeed = (speed: number): string => {
  if (speed === 1) return "Normal";
  if (speed < 1) return `Slow (${speed}x)`;
  return `Fast (${speed}x)`;
};

export const formatLanguage = (code: string): string => {
  return LANGUAGES.find((l) => l.code === code)?.name ?? code.toUpperCase();
};

export const formatTurnMode = (mode: string): string => {
  if (mode === "silence") return "Wait for silence";
  if (mode === "turn") return "Take turns speaking";
  return mode;
};

export const truncateText = (text: string, maxLength: number = 50): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

export const formatTimeAgo = (dateString: string): string => {
  if (!dateString) return "Unknown";
  try {
    // Handle ISO strings with timezone offset (e.g., +00:00) or Z
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Unknown";
    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return "Unknown";
  }
};

export const formatExactTime = (dateString: string): string => {
  if (!dateString) return "Unknown";
  try {
    // Handle ISO strings with timezone offset (e.g., +00:00) or Z
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Unknown";
    return format(date, "h:mm a");
  } catch {
    return "Unknown";
  }
};